import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "./SimplePresentationRunner";

export class DoNothing implements SimplePresentation {

    shouldRun(): boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        controller.finish();
    }
}